<template>
  <v-container
    v-if="anytimeConsultations"
    grid-list-xs
    fluid
    class="pa-0"
  >
    <v-container
      class="pa-0"
      fluid
    >
      <div
        v-for="consultation in anytimeConsultations"
        :key="consultation.id"
        class="anytime-consultation-info"
        :class="{
          'anytime-consultation-excluded': consultation.excluded,
          'anytime-consultation-selected': selectedIds.includes(consultation.id)
        }"
      >
        <div class="d-flex align-stretch">
          <div
            v-if="bulkToolbarOpen"
            class="card-select-column"
          >
            <input
              type="checkbox"
              :checked="selectedIds.includes(consultation.id)"
              @change="$emit('toggle-selection', { id: consultation.id, checked: $event.target.checked })"
            >
          </div>

          <div class="flex-grow-1">
            <div
              v-if="consultation.excluded"
              class="excluded-badge"
            >
              除外中
            </div>

            <anytimeConsultationDetail
              :anytime-consultation="consultation"
              :search-layout="true"
            />

            <v-row
              v-if="consultation.answer"
              noguide
              class="anytime-consultation-info-answer"
            >
              <v-col
                cols="12"
                class="pa-0"
              >
                <v-textarea
                  v-model="consultation.answer"
                  label="回答"
                  rows="10"
                  class="text-grey"
                  :class="{ 'excluded-answer': consultation.excluded }"
                  color="grey-darken-4"
                  variant="outlined"
                  hide-details
                  :readonly="true"
                  @mousedown="logCopyEvent(consultation)"
                />
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
    </v-container>
  </v-container>
</template>

<script>
import axios from "axios";
import AnytimeConsultationDetail from "../../../components/shared/AnytimeConsultationDetailCard.vue";

export default {
  name: "AnytimeConsultationSearchResults",
  components: {
    AnytimeConsultationDetail
  },
  props: {
    anytimeConsultations: {
      type: Array,
      default: () => []
    },
    totalCount: {
      type: Number,
      default: 0
    },
    excludedCount: {
      type: Number,
      default: 0
    },
    previousKeys: {
      type: Object,
      default: null
    },
    selectionResetKey: {
      type: Number,
      default: 0
    },
    bulkToolbarOpen: {
      type: Boolean,
      default: false
    },
    selectedIds: {
      type: Array,
      default: () => []
    }
  },
  emits: ["toggle-selection"],
  methods: {
    logCopyEvent: function(consultation) {
      if (!this.previousKeys) return;

      axios.post("/api/v1/anytime_consultations/log_copy_event", {
        consultation: consultation,
        search_keys: this.previousKeys
      }).then(
      ).catch(error => {
        console.log(error);
      });
    }
  }
};
</script>

<style lang="scss">
  .anytime-consultation-search-info {
    background-color: #fafafa;
    margin: 2px 2px 8px 2px;
    border-left: 3px solid #0076c0;

    .v-card__text {
      background-color: #fafafa;
      color: #4b5563;
      font-size: 13px;
    }
  }

  .anytime-consultation-info {
    border: solid 1px #9ca3af;
    background-color: white;
    border-radius: 2px;
    position: relative;
    margin-bottom: 14px;

    .v-card {
      border: solid 1px #bdbdbd !important;
      height: 100%;
    }

    .anytime-consultation-info-answer {
      margin: 6px;
    }
  }

  .card-select-column {
    width: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: solid 1px #cfcfcf;
    background-color: #f7f7f7;
  }

  .anytime-consultation-selected {
    background-color: #eef6ff;
    border-color: #0076c0;
  }

  .anytime-consultation-excluded {
    background-color: #efefef;
    color: #666;
  }

  .anytime-consultation-excluded.anytime-consultation-selected {
    background-color: #fff9c4;
  }

  .excluded-badge {
    position: absolute;
    left: 56px;
    top: 8px;
    background-color: #555;
    color: #fff;
    font-size: 10px;
    font-weight: bold;
    padding: 2px 7px;
    border-radius: 10px;
    z-index: 1;
  }

  .excluded-answer {
    font-style: italic;
  }
</style>
